import React from "react";
import PropTypes from "prop-types";
import { KeyboardDateTimePicker } from "@material-ui/pickers";

const FormDateTimeField = ({
  input,
  label,
  disableFuture,
  meta: { touched, error },
  minDate,
  defaultValue = undefined,
}) => (
  <KeyboardDateTimePicker
    label={label}
    ampm={false}
    error={touched && error ? true : false}
    helperText={touched && error}
    margin="dense"
    minDate={minDate}
    disableFuture={disableFuture}
    InputLabelProps={{
      shrink: true,
    }}
    autoOk
    okLabel="OK"
    cancelLabel="Anuluj"
    clearLabel="Wyczyść"
    invalidLabel="Wybierz ..."
    onChange={(value) => input.onChange(value)}
    format="DD.MM.YYYY HH:mm:ss"
    value={input.value ? input.value.toDate() : defaultValue}
  />
);

FormDateTimeField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  minDate: PropTypes.object,
  disableFuture: PropTypes.bool,
  defaultValue: PropTypes.any,
};

export default FormDateTimeField;
